module.exports = __webpack_public_path__ + "img/EFireship64_ua.da046ad9.webp";